/**
 * Copyright 2021 Olympe S.A.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { ActionBrick, registerBrick, CloudObject, Transaction, ErrorFlow, WorkflowTransition, } from 'olympe';
import { getLogger } from '@olympeio/core';
import { triggerTransition } from './_workflow';

export default class WorkflowTriggerTransition extends ActionBrick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!CloudObject} object
     * @param {!WorkflowTransition} transition
     * @param {Map} data
     * @param {function()} forwardEvent
     * @param {function(!ErrorFlow)} setErrorFlow
     * @param {function(!CloudObject)} setObject
     */
    async update($, [object, transition, data], [forwardEvent, setErrorFlow, setObject]) {
        try {
            setObject(object); // done in any case

            const t = Transaction.from($);
            triggerTransition($, t, object, transition, data).then(() => {
                Transaction.process($, t)
                    .then(forwardEvent)
                    .catch(error => {
                        const errorMessage = `Setting State Error: ${error}`;
                        getLogger('Trigger Workflow Transition').error(errorMessage);
                        setErrorFlow(ErrorFlow.create(errorMessage, 3));
                    });
            });
        }
        catch(error) {
            const errorMessage = error.message;
            getLogger('Trigger Workflow Transition').error(errorMessage);
            setErrorFlow(ErrorFlow.create(errorMessage, 4));
        }
    }
}

registerBrick('0180d164e1f8fcd42658', WorkflowTriggerTransition);
